// Frans (fr-FR), groeiSchoolApp: zelfde vorm als groeiSchoolApp.nl.ts (golf 3-integratie). Tu-vorm,
// geen oordeel over een kind. Nederlandse schoolnamen (AVI, Cito, vmbo, havo, vwo, groep) blijven
// staan: zo staan ze op het rapport. De toestemming valt onder GROWTH_CONSENT_TEXT_HASHES.
export const appGrowthFr = {
    title: 'Croissance',
    intro: 'La taille et le poids de vos enfants, tranquillement sur une courbe de croissance. Seuls les parents le voient. Pas sur la tablette, sauf si un parent le confirme lui-même expressément pour une tablette ; cela peut toujours être retiré.',
    tab: 'Croissance',
    empty: 'Pas encore de mesures. Mesure tranquillement, par exemple après le consultatiebureau ou la JGZ.',
    measurements: '{count} mesures',
    measurementsOne: '1 mesure',
    lastOn: 'Dernière mesure le {date}',
    open: 'Croissance de {name}',
    noConsentYet: 'Pas encore activé',
    noMeasurements: 'Pas encore de mesures',
    consent: {
        version: '2026-10-08.1',
        title: 'Suivre la croissance de {name} ?',
        parental: {
            text: 'La taille et le poids sont des données de santé. Nous les conservons uniquement pour montrer la croissance de {name} sur un graphique.\nSi tu choisis un groupe de référence pour la courbe de croissance (enfants d’origine turque, marocaine ou hindoustanie (surinamienne) aux Pays-Bas), nous conservons aussi ce choix. Il révèle quelque chose sur l’origine.\nSi {name} est né avant terme, tu peux indiquer la durée de la grossesse à la naissance. C’est aussi une donnée de santé.\nSeuls les parents de cette famille le voient. Jamais pour les enfants et jamais pour la famille associée. Pas sur la tablette, sauf si un parent le confirme lui-même expressément pour une tablette ; cela peut toujours être retiré.\nTu peux tout télécharger. Retirer ton consentement efface immédiatement toutes les mesures et tous les choix de {name} ; ils disparaissent des sauvegardes sous 90 jours.\nLes lignes sont une aide, pas un jugement ni un diagnostic. En cas de doute, demande au consultatiebureau ou à la JGZ.\nAMUMIN B.V. est responsable de ces données. Tes droits figurent dans la déclaration de confidentialité.',
            check: 'Je suis parent de {name} ({name} a moins de 16 ans) et je consens au suivi de la taille, du poids et des choix pour la courbe de croissance de {name}.',
        },
        self: {
            text: 'La taille et le poids sont des données de santé. Nous les conservons uniquement pour montrer ta croissance sur un graphique.\nSi un groupe de référence est choisi pour ta courbe de croissance (par exemple d’origine turque, marocaine ou hindoustanie (surinamienne) aux Pays-Bas), nous conservons aussi ce choix. Il révèle quelque chose sur l’origine. Il en va de même pour la durée de la grossesse à ta naissance si tu es né avant terme : c’est une donnée de santé.\nSeuls les parents de cette famille le voient (donc aussi l’autre parent). Jamais pour les enfants et jamais pour la famille associée. Pas sur la tablette, sauf si un parent le confirme lui-même expressément pour une tablette ; cela peut toujours être retiré.\nTu peux tout télécharger. Retirer ton consentement efface immédiatement toutes tes mesures et tous tes choix ; ils disparaissent des sauvegardes sous 90 jours.\nAMUMIN B.V. est responsable de ces données. Tes droits figurent dans la déclaration de confidentialité.',
            check: 'Je consens au suivi de ma propre taille, de mon propre poids et des choix pour ma courbe de croissance.',
        },
        /**
         * Aanvulling (0051, tekst 2026-09-28.1): gevraagd op het moment dat een ouder een keuze maakt
         * die een oudere toestemming niet noemde (hs_nl, zwangerschapsduur; bij `self` elke groep
         * behalve nl). De aanvulling noemt altijd ALLE keuzes die die tekst toevoegt (groep en
         * zwangerschapsduur), ook als de ouder er nu maar één kiest: dan dekt ze ze ook echt (review
         * gpl-reg r1). Hoort bij dezelfde hash als parental en self.
         */
        extension: {
            title: 'Consentement pour ces choix',
            intro: 'Tu as déjà donné ton consentement pour la Croissance de {name}. Le texte de l’époque ne mentionnait pas encore tout ce que tu peux choisir maintenant. C’est pourquoi nous demandons séparément ton consentement pour ces deux choix, même si tu n’en choisis qu’un maintenant :',
            group: 'Un groupe de référence pour les lignes, par exemple d’origine turque, marocaine ou hindoustanie (surinamienne) aux Pays-Bas. Ce choix révèle quelque chose sur l’origine : c’est une catégorie particulière de données personnelles.',
            gestation: 'La durée de la grossesse à la naissance, si {name} est né avant terme (22 à 36 semaines). C’est une donnée de santé.',
            rest: 'Nous l’utilisons uniquement pour les lignes du graphique. Seuls les parents de cette famille le voient. Pas sur la tablette, sauf si un parent le confirme lui-même expressément pour une tablette ; cela peut toujours être retiré. Retirer ton consentement l’efface immédiatement, avec les mesures. Les lignes ne sont ni un jugement ni un diagnostic.\nAvec ce consentement, le texte le plus récent du consentement pour la Croissance s’applique à {name}.',
            check: 'Je consens à la conservation de ces choix pour {name}.',
            selfText: 'Tes parents peuvent choisir un groupe de référence pour ta courbe de croissance (par exemple d’origine turque, marocaine ou hindoustanie (surinamienne) aux Pays-Bas). Cela révèle quelque chose sur l’origine. Si tu es né avant terme, ils peuvent aussi indiquer la durée de la grossesse à ta naissance : c’est une donnée de santé. Les deux nécessitent ton consentement.',
            selfCheck: 'Je consens à la conservation de ces choix pour ma propre courbe de croissance.',
            give: 'Consentir et enregistrer',
            giveSelf: 'Donner mon consentement',
            needsOwn: '{name} décide personnellement : {name} peut l’autoriser dans Croissance, dans sa propre application.',
            selfTitle: 'Ton consentement, avec le nouveau texte',
            extended: 'Complété le {date} avec le texte le plus récent.',
        },
        give: 'Donner mon consentement',
        privacyLink: 'Lire la déclaration de confidentialité',
        notNow: 'Pas maintenant',
        needsOwn: 'Pour {name}, seul(e) {name} peut donner son consentement, avec son propre compte.',
        needsOwnTeen: 'À partir de 16 ans, {name} décide seul(e). Avec son propre compte, {name} peut donner son consentement dans Croissance ; ensuite vous pourrez saisir les mesures.',
        lapsed: '{name} a maintenant 16 ans et décide seul(e). Tu peux encore consulter, télécharger ou effacer les mesures, mais plus en ajouter.',
        given: 'Consentement donné le {date}',
        givenSelf: 'Tu as donné ton consentement le {date}',
        givenByThem: '{name} a donné son consentement le {date}',
        withdraw: 'Retirer le consentement et tout effacer',
        withdrawTitle: 'Retirer le consentement ?',
        withdrawBody: 'Toutes les mesures de {name} sont effacées immédiatement, ainsi que le choix pour la courbe de croissance. C’est irréversible.',
        withdrawConfirm: 'Retirer et effacer',
        withdrawn: 'Consentement retiré. Les mesures de {name} sont effacées.',
    },
    add: 'Ajouter une mesure',
    edit: 'Modifier la mesure',
    date: 'Date',
    length: 'Taille (cm)',
    weight: 'Poids (kg)',
    lengthShort: 'Taille',
    weightShort: 'Poids',
    bmi: 'IMC',
    wflShort: 'Poids/taille',
    note: 'Note (facultative)',
    notePlaceholder: 'Par exemple : mesuré à la JGZ',
    oneOfBoth: 'Indique la taille, le poids ou les deux.',
    saved: 'Mesure enregistrée',
    deleted: 'Mesure supprimée',
    deleteConfirm: 'Supprimer cette mesure ?',
    errors: {
        empty: 'Indique la taille, le poids ou les deux.',
        length_range: 'Cette taille n’est pas correcte. Indique-la en centimètres, par exemple 123,5.',
        weight_range: 'Ce poids n’est pas correct. Indique-le en kilos, par exemple 24,5.',
        future: 'Cette date est dans le futur.',
        before_birth: 'Cette date est antérieure à la date de naissance.',
        note_long: 'La note est trop longue (200 caractères maximum).',
        format: 'Utilise au maximum un chiffre après la virgule.',
    },
    chart: {
        length: 'Taille selon l’âge',
        weight: 'Poids selon l’âge',
        bmi: 'IMC selon l’âge',
        wfl: 'Poids selon la taille',
        bmiFrom2: 'Nous montrons l’IMC à partir de 2 ans.',
        age: 'Âge (années)',
        date: 'Date',
        median: 'Milieu (moyenne)',
        sd1: '−1 et +1 ET',
        sd2: '−2 et +2 ET',
        you: '{name}',
        lastPoint: 'Dernière mesure : {value} le {date}',
        info: 'Les lignes sont une aide, pas un jugement ni un diagnostic. En cas de doute, demande au consultatiebureau ou à la JGZ.',
        gaps: {
            no_sex: 'Choisis garçon ou fille ci-dessous pour voir les lignes de croissance.',
            no_group: 'Choisis un groupe de référence ci-dessous pour voir les lignes de croissance. Sans choix, tu ne vois que les mesures.',
            no_birth_date: 'Indique la date de naissance pour voir la croissance selon l’âge.',
        },
        source: 'Source des lignes : {source}',
        sources: {
            schonbeck_2011: 'Enfants néerlandais, 2009 ({cite})',
            tno_2010: 'Enfants néerlandais, 2009 ({cite})',
            tno_2010_origin: 'Enfants {group} aux Pays-Bas, 2009 ({cite})',
            fredriks_2000: 'Enfants néerlandais, 1997 ({cite})',
            fredriks_2003: 'Enfants {group} aux Pays-Bas, 1997 ({cite})',
            fredriks_2004: 'Enfants {group} aux Pays-Bas, 1997 ({cite})',
            de_wilde_2014: 'Enfants {group} aux Pays-Bas, 2010 ({cite})',
            de_wilde_2013: 'Enfants {group} aux Pays-Bas, 1976 ({cite})',
            bocca_2012: 'Enfants nés après {weeks} semaines de grossesse ({cite})',
            bocca_2012_wfh: 'Enfants nés trop tôt ({cite})',
        },
        citations: {
            schonbeck_2011: 'Schönbeck et al., PLoS ONE 2011, CC BY',
            tno_2010: 'TNO, Groeidiagrammen 2010',
            tno_2010_origin: 'TNO, Groeidiagrammen 2010',
            fredriks_2000: 'TNO, Fredriks et al. 2000',
            fredriks_2003: 'TNO, Fredriks et al. 2003',
            fredriks_2004: 'TNO, Fredriks et al. 2004',
            de_wilde_2014: 'TNO, de Wilde et al. 2014',
            de_wilde_2013: 'TNO, de Wilde et al. 2013',
            bocca_2012: 'TNO, Bocca-Tjeertes et al. 2012',
            bocca_2012_wfh: 'TNO, Bocca-Tjeertes et al. 2012',
        },
        /** Golf 19: welke lijnen waar gelden (een tabel per stuk, zie referenceSegments). */
        rangeUntil: 'jusqu’à {age} ans :',
        rangeBetween: 'de {from} à {to} ans :',
        rangeFrom: 'à partir de {age} ans :',
        sourceJoin: ' ; ',
        switchNote: 'À {age} ans, les lignes passent à un autre tableau (voir la source ci-dessous). Elles peuvent y faire un petit saut.',
        pretermNote: 'Jusqu’à {age} ans, tu vois les lignes des enfants nés après {weeks} semaines de grossesse, selon l’âge depuis la naissance. Ensuite, les lignes habituelles.',
        pretermWflNote: 'Jusqu’à {age} ans, tu vois ici les lignes des enfants nés trop tôt. Ensuite, les lignes habituelles.',
        table: 'Tableau de toutes les mesures',
        showTable: 'Afficher en tableau',
        showChart: 'Afficher en graphique',
    },
    settings: {
        title: 'Courbe de croissance',
        sex: 'Sexe (pour les lignes de croissance)',
        sexUnset: 'Non choisi',
        female: 'Fille',
        male: 'Garçon',
        group: 'Groupe de référence',
        groupHint: 'Uniquement pour les lignes du graphique. Choisis ce qui convient le mieux ; tu peux toujours le changer ou le laisser vide.',
        groups: {
            none: 'Aucun (mesures seulement)',
            nl: 'Enfants néerlandais',
            tr_nl: 'Enfants d’origine turque aux Pays-Bas',
            ma_nl: 'Enfants d’origine marocaine aux Pays-Bas',
            hs_nl: 'Enfants d’origine hindoustanie (surinamienne) aux Pays-Bas',
        },
        groupNames: {
            nl: 'néerlandais',
            tr_nl: 'd’origine turque',
            ma_nl: 'd’origine marocaine',
            hs_nl: 'd’origine hindoustanie (surinamienne)',
        },
        /** Golf 19: neutrale uitleg bij de groepen en de zwangerschapsduur (alleen te vroeg). */
        groupInfo: 'Les lignes de chaque groupe viennent de recherches néerlandaises auprès d’enfants de cette origine. Hindoustani (surinamien) désigne des enfants aux ancêtres sud-asiatiques, souvent venus par le Suriname. Tous les groupes n’ont pas leurs propres lignes pour chaque mesure ; sous le graphique, tu vois quelles lignes sont affichées.',
        gestation: 'Durée de la grossesse à la naissance',
        gestationNone: 'Né à terme (ou non renseigné)',
        gestationWeeks: '{weeks} semaines',
        gestationHint: 'À remplir seulement si {name} est né trop tôt (avant {term} semaines). Jusqu’à {age} ans, tu vois alors les lignes des enfants nés trop tôt ; de {min} à {max} semaines, ce sont les lignes de {table} semaines. C’est une donnée de santé : elle relève du même consentement que les mesures, seuls les parents la voient, et le retrait l’efface aussi.',
        saved: 'Enregistré',
    },
    birthDate: 'Date de naissance de {name}',
    birthDateHint: 'Nécessaire pour la croissance selon l’âge. Figure aussi dans les Anniversaires.',
    download: 'Télécharger',
    downloadCsv: 'En tableau (CSV)',
    downloadJson: 'Tout (JSON)',
    clear: 'Effacer toutes les mesures',
    clearTitle: 'Effacer toutes les mesures de {name} ?',
    clearBody: 'Le consentement reste valable, pour que tu puisses recommencer. C’est irréversible.',
    cleared: 'Toutes les mesures de {name} sont effacées.',
    privacyNote: 'Seuls les parents le voient. Pas sur la tablette, sauf si un parent le confirme lui-même expressément pour une tablette ; cela peut toujours être retiré.',
    selfIntro: 'Ta taille et ton poids, calmement dans une courbe de croissance. Tes parents saisissent les mesures ; seuls toi et tes parents le voient.',
    selfUnder16: 'Tes parents suivent ta taille et ton poids. À partir de 16 ans, tu décides toi-même.',
    selfNote: 'Seuls toi et tes parents le voient. Pas sur la tablette, sauf si un parent le confirme lui-même expressément pour une tablette ; cela peut toujours être retiré.',
    /** Kolomkoppen van de CSV-download (review g3-fs r1: in de taal van het gezin). */
    csvHead: ['date', 'taille_cm', 'poids_kg', 'imc', 'note'],
    moduleOff: 'Croissance fait partie du module Santé. Il est désactivé.',
};
export const appSchoolFr = {
    title: 'École',
    intro: 'Notes de bulletin et tests par enfant, tranquillement sur une frise. Seuls les parents le voient ; jamais sur la tablette.',
    childIntro: 'Tes bulletins et tes tests. Tes parents les remplissent.',
    childOff: 'Tes parents ne l’ont pas encore activé pour toi.',
    tab: 'École',
    open: 'École de {name}',
    noChildren: 'Il n’y a pas encore d’enfants dans votre famille.',
    empty: 'Rien de rempli pour l’instant. Commence par le dernier bulletin ou un test.',
    nothingYet: 'Rien de rempli pour l’instant',
    count: '{count} résultats',
    countOne: '1 résultat',
    add: 'Ajouter un résultat',
    edit: 'Modifier le résultat',
    saved: 'Enregistré',
    deleted: 'Supprimé',
    deleteConfirm: 'Supprimer ce résultat ?',
    timeline: 'Frise',
    trends: 'Par matière',
    noTrend: 'Une ligne apparaît dès qu’il y a deux résultats ou plus.',
    childView: '{name} peut-il le voir lui-même ?',
    childViewHint: 'Seulement avec son propre compte dans l’application web, seulement ses propres résultats et en lecture seule. Jamais sur la tablette.',
    childViewOn: '{name} peut maintenant le voir lui-même.',
    childViewOff: '{name} ne le voit pas.',
    download: 'Télécharger',
    downloadCsv: 'En tableau (CSV)',
    downloadJson: 'Tout (JSON)',
    clear: 'Tout effacer pour {name}',
    clearTitle: 'Effacer tous les résultats de {name} ?',
    clearBody: 'C’est irréversible.',
    cleared: 'Tous les résultats de {name} sont effacés.',
    field: {
        kind: 'Type',
        schoolYear: 'Année scolaire',
        period: 'Moment',
        date: 'Date (facultative)',
        group: 'Groupe (groep)',
        groupNone: 'Inconnu',
        subject: 'Matière',
        domain: 'Domaine',
        scale: 'Échelle',
        grade: 'Note',
        gradeHint: 'De 1 à 10, par exemple 7,5',
        word: 'Appréciation',
        level: 'Niveau',
        score: 'Score de compétence (facultatif)',
        dmtScore: 'Score (nombre de mots justes)',
        provider: 'Test de (facultatif)',
        note: 'Note (facultative)',
    },
    errors: {
        school_year: 'Choisis une année scolaire.',
        period: 'Choisis un moment qui correspond à ce type.',
        group: 'Choisis un groupe de 1 à 8.',
        subject: 'Choisis une matière.',
        domain: 'Choisis un domaine.',
        scale: 'Choisis une échelle.',
        value: 'Cette valeur ne correspond pas à l’échelle.',
        provider: 'Choisis un test dans la liste.',
        note: 'La note est trop longue (200 caractères maximum).',
        future: 'Cette date est dans le futur.',
        subject_dup: 'Cette matière existe déjà.',
    },
    /** Titels van een lijn "Per vak" (review g3-ux r1): rapport en toets nooit dezelfde titel. */
    titles: {
        grade: '{subject} · bulletin',
        lvs: 'Test · {domain}',
    },
    kinds: {
        grade: 'Note de bulletin',
        lvs: 'Test (suivi des élèves, LVS)',
        avi: 'Niveau de lecture AVI',
        dmt: 'DMT (test de trois minutes)',
        level: 'Niveau de fonctionnement (functioneringsniveau)',
        doorstroom: 'Test de passage groupe 8 (doorstroomtoets)',
        advies: 'Avis scolaire (schooladvies)',
    },
    periods: {
        b: 'Début',
        r1: 'Bulletin 1',
        m: 'Milieu',
        r2: 'Bulletin 2',
        r3: 'Bulletin 3',
        e: 'Fin',
        r4: 'Bulletin 4',
        voorlopig: 'Provisoire',
        definitief: 'Définitif',
    },
    periodsShort: {
        b: 'D',
        r1: 'B1',
        m: 'M',
        r2: 'B2',
        r3: 'B3',
        e: 'F',
        r4: 'B4',
        voorlopig: 'prov.',
        definitief: 'déf.',
    },
    scales: {
        number: 'Note 1-10',
        word: 'Mots (de O à ZG)',
        roman: 'De I à V',
        letter: 'De A à E',
        ref: '1F / 2F / 1S',
    },
    domains: {
        rekenen: 'Calcul',
        begrijpend_lezen: 'Compréhension écrite',
        spelling: 'Orthographe',
        technisch_lezen: 'Lecture technique',
        lezen: 'Lecture',
        taalverzorging: 'Maîtrise de la langue',
    },
    providers: {
        cito: 'Cito (Leerling in beeld)',
        boom: 'Boom LVS',
        iep: 'IEP',
        dia: 'Diatoetsen',
        amn: 'AMN',
        route8: 'ROUTE 8',
        doe: 'DOE-toets',
        other: 'Autre',
    },
    words: {
        O: 'Insuffisant',
        M: 'Médiocre',
        V: 'Suffisant',
        RV: 'Plus que suffisant',
        G: 'Bien',
        ZG: 'Très bien',
    },
    advice: {
        pro: 'Praktijkonderwijs (enseignement pratique)',
        vmbo_b: 'vmbo basis',
        vmbo_b_k: 'vmbo basis / kader',
        vmbo_k: 'vmbo kader',
        vmbo_k_gt: 'vmbo kader / gt',
        vmbo_gt: 'vmbo gemengd/theoretisch (gt)',
        vmbo_gt_havo: 'vmbo gt / havo',
        havo: 'havo',
        havo_vwo: 'havo / vwo',
        vwo: 'vwo',
    },
    explain: {
        grade: 'Une note de bulletin de 1 à 10. Un 5,5 ou plus est suffisant.',
        word: '{code} = {word}.',
        aviStart: 'AVI-Start = le début de l’apprentissage de la lecture, en groupe 3.',
        aviPlus: 'AVI-Plus = le niveau AVI le plus élevé, après la fin du groupe 7.',
        avi: 'AVI {code} = le niveau de lecture {moment} groupe {group}.',
        level: '{code} = le niveau {moment} groupe {group}.',
        roman: {
            I: 'I = parmi les 20 % d’enfants les plus avancés aux Pays-Bas.',
            II: 'II = juste au-dessus de la moyenne (les 20 % suivants).',
            III: 'III = autour de la moyenne (les 20 % du milieu).',
            IV: 'IV = juste en dessous de la moyenne (les 20 % suivants).',
            V: 'V = parmi les 20 % les moins avancés. L’école regarde alors ce qui peut aider en plus.',
        },
        letter: {
            A: 'A = parmi les 25 % d’enfants les plus avancés aux Pays-Bas.',
            B: 'B = juste au-dessus de la moyenne (les 25 % suivants).',
            C: 'C = juste en dessous de la moyenne (les 25 % suivants).',
            D: 'D = nettement en dessous de la moyenne (les 15 % suivants).',
            E: 'E = parmi les 10 % les moins avancés. L’école regarde alors ce qui peut aider en plus.',
        },
        ref: {
            '<1F': '1F pas encore atteint. C’est le niveau de base pour la fin du groupe 8.',
            '1F': '1F = le niveau de base que presque tous les enfants atteignent en fin de groupe 8.',
            '2F': '2F = le niveau visé en lecture et en langue en fin de groupe 8.',
            '1S': '1S = le niveau visé en calcul en fin de groupe 8.',
        },
        dmt: 'Le DMT mesure combien de mots isolés un enfant lit correctement en trois minutes.',
        doorstroom: 'Le test de passage (depuis 2024) mesure la lecture, la maîtrise de la langue et le calcul en 1F, 2F et 1S.',
        advies: 'L’avis scolaire indique quel type d’enseignement secondaire convient.',
        moments: { B: 'au début du', M: 'au milieu du', E: 'à la fin du' },
    },
    subjects: {
        title: 'Matières',
        hint: 'Les matières du bulletin de votre école. Tu peux les renommer ou les retirer ; les anciennes notes restent.',
        add: 'Ajouter une matière',
        name: 'Nom de la matière',
        suggested: 'Ajouter les matières habituelles',
        suggestions: [
            'Calcul',
            'Langue',
            'Orthographe',
            'Lecture',
            'Compréhension écrite',
            'Écriture',
            'Géographie',
            'Histoire',
            'Sciences',
            'Anglais',
        ],
        remove: 'Retirer',
        rename: 'Renommer',
        removed: 'Matière retirée. Les anciennes notes restent.',
        none: 'Pas encore de matières. Ajoute-les ou choisis les matières habituelles.',
        archived: '{name} (retirée)',
    },
    /** Kolomkoppen van de CSV-download (review g3-fs r1: in de taal van het gezin). */
    csvHead: [
        'annee_scolaire',
        'periode',
        'date',
        'groupe',
        'type',
        'matiere_ou_domaine',
        'valeur',
        'test',
        'note',
    ],
    moduleOff: 'École est désactivé.',
};
//# sourceMappingURL=groeiSchoolApp.fr.js.map